import { useMemo, useState } from "react";
import ShowSuccessToastContext, {
  ShowSuccessToastType,
} from "./showSuccessToastContext";

const ShowSuccessToastProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const initialState = {
    open: false,
    successMessage: "",
    successTitle: "",
  };
  const [showSuccessToastState, showSuccessToastSetState] =
    useState<ShowSuccessToastType>(initialState);

  const stateValue = useMemo(
    () => [{ showSuccessToastState, showSuccessToastSetState }],
    [showSuccessToastState, showSuccessToastSetState]
  );

  return (
    <ShowSuccessToastContext.Provider value={stateValue}>
      {children}
    </ShowSuccessToastContext.Provider>
  );
};

export default ShowSuccessToastProvider;
